import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import { useTranslation } from "providers/i18n"
import { useTheme } from "@mui/material"

interface IErrorDialogProps {
  open: boolean
  title: string
  description: string
  onClose: () => void
  buttonText: string
}

export const ErrorDialog = ({
  open = false,
  title: errorTitle = null,
  description = null,
  onClose = () => {},
  buttonText,
}: IErrorDialogProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides = theme.components?.[`ErrorDialog`]?.styleOverrides || {}

  const { root, paper, title, content, contentText, buttonContainer, button } =
    styleOverrides

  return (
    <Dialog
      sx={root}
      className="ErrorDialog"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: paper }}
    >
      <DialogTitle sx={title} id="alert-dialog-title">
        {errorTitle && errorTitle}
      </DialogTitle>
      <DialogContent sx={content}>
        {description && (
          <DialogContentText sx={contentText}>{description}</DialogContentText>
        )}
      </DialogContent>
      <DialogActions sx={buttonContainer}>
        <Button sx={button} onClick={onClose}>
          {buttonText ? buttonText : t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
